import { render, staticRenderFns } from "./CardTile.vue?vue&type=template&id=2093055d&scoped=true"
import script from "./CardTile.vue?vue&type=script&lang=js"
export * from "./CardTile.vue?vue&type=script&lang=js"
import style0 from "./CardTile.vue?vue&type=style&index=0&id=2093055d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093055d",
  null
  
)

export default component.exports